import { useCategoriesQuery } from '@/api'
import { useMemo } from 'react'

export const useCategories = () => {
  const {
    data: categoriesData,
    loading,
    error,
  } = useCategoriesQuery({
    variables: { brandId: process.env.NEXT_PUBLIC_BRAND_ID_CANADAGOOSE || '' },
    fetchPolicy: 'cache-and-network',
  })

  const categoryAll = categoriesData?.categories || []

  const getCategoryId = (categoryName: string): string | null => {
    const category = categoryAll.find((cat) => cat.name === categoryName)
    return category?.id || null
  }

  const categories = useMemo(
    () => ({
      parka: getCategoryId('パーカ（ダウン）'),
      bomber: getCategoryId('ボンバー'),
      lightweight: getCategoryId('ライトウェイトダウンジャケット'),
      puffer: getCategoryId('パッファージャケット'),
      rainWind: getCategoryId('レイン＆ウィンド'),
      vest: getCategoryId('ベスト'),
      outerwear: getCategoryId('アウターウェア'),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [categoryAll]
  )

  return {
    categories,
    loading,
    error,
  }
}
